<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
  >
    <path
      d="M17.2891 1.46289L9.859 10.4722L1.25422 2.1814"
      stroke="black"
      stroke-width="1.5"
    />
  </svg>
</template>

<script>
export default {
  name: 'FilterCaret',
};
</script>
